// extracted by mini-css-extract-plugin
export default {"WarningText":"_WarningText--aHmrL","ActionButtons":"_ActionButtons--XXmXA"};